import config from 'configDir/index';
import { get, post } from './http';

const baseUrl = '/enterprise';

//  模糊查询企业
const searchEnterpriseService = get(`${baseUrl}/searchEnterprise`, config.resourceUrl);

//  查询企业
const queryEnterpriseService = get(`${baseUrl}/queryEnterprise`, config.resourceUrl);

//  查询企业
const postEnterpriseService = post(`${baseUrl}/queryEnterprise`, config.resourceUrl);

// 查岗对象-可用企业
const queryEnableDutyEntsService = get(`${baseUrl}/enableDutyEnts`, config.resourceUrl);

// 查询企业详情
const queryEnterpriseInfoService = get(`${baseUrl}/queryEnterpriseInfo`, config.resourceUrl);

export {
  searchEnterpriseService,
  queryEnterpriseService,
  postEnterpriseService,
  queryEnableDutyEntsService,
  queryEnterpriseInfoService,
};
